import { BasicSuccessPage } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPage";
import {
	faThumbsUp as fasThumbsUp,
	faExclamation as fasExclamation,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class SuccessPage extends BasicSuccessPage {
	protected renderContent(): ReactNode {
		const { title } = this.props;

		return (
			<>
				<Card.Header>
					<div className="h4 mb-0 font-weight-bold text-center">{title}</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column justify-content-center text-white">
					<div className="d-flex px-3 py-2 border-bottom">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fasThumbsUp} className="text-gold" size="4x" />
						</div>
						<div className="font-weight-bold my-auto mr-auto ml-3">
							A részletes eredményeket megküldtük az <strong>e-mail címedre!</strong>
						</div>
					</div>
					<div className="d-flex p-2">
						<div className="text-center border-right my-auto ml-auto">
							<FontAwesomeIcon icon={fasExclamation} className="p-2" size="3x" />
						</div>
						<div className="text-white my-auto mr-auto ml-3">
							Ha nem találod az e-mailünket, nézd meg a levélszemét (spam) mappában is!
						</div>
					</div>
				</Card.Body>
				{this.renderSubscribe()}
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
